module.exports = __webpack_public_path__ + "static/extremetech-f21c9ff7b7c32c9915a5eea5e84c851a.svg";